import apiClient from './api';

const dashboardService = {
    /**
     * Aggregate home-page stat counts in one call.
     * @param {number|null} officeSpaceId - scope to a shop; omit for the user's own totals
     * @returns {Promise<object>} { data: { aiPhotos, manualEdited, bulkEdited,
     *   aiTemplateImages, documents, printMedia, questionPapers } }
     */
    getStats: async (officeSpaceId = null) => {
        const params = officeSpaceId ? { officeSpaceId } : {};
        return apiClient.get('/api/dashboard/stats', { params });
    },
};

export default dashboardService;
